import app from '@/common/public.js';
const { Post, GetResultState } = app;
import { apiName } from '@/common/config.js';
import store from '@/store/index.js';

export async function generateUrl(productType, orderNo, orderStatus, groupid) {
  const configs = [getAppKey(), getDefaultGroupId()];
  const [appKey, defaultGroupId] = await Promise.all(configs);
  return new Promise((resolve) => {
    const settings = app.GetSettings();
    const settingInfo = JSON.stringify({
      MemberId: settings.MemberInfo.MemberId,
      PlatId: settings.platId,
      Version: settings.Version,
    });
    const paramsStr = `?appKey=${appKey}&settingInfo=${settingInfo}&productType=${productType}&orderNo=${orderNo}&orderStatus=${orderStatus}&groupid=${
      groupid || defaultGroupId
    }`;
    let callbackUrl = '';

    callbackUrl =
      window.location.protocol +
      '//' +
      window.location.host +
      '/hybrid/html/online_service.html' +
      paramsStr +
      '&isApp=0';




    let url = '/pages/index/iframeWeb?paramUrl=' + encodeURIComponent(JSON.stringify(callbackUrl));
    resolve(url);
  });
}

// 获取七鱼的appKey
export function getAppKey() {
  return new Promise((resolve, reject) => {
    const appKey = store.state.temporary.appKey;
    let key = 'OnlineServiceDialogQiYuAppID';
    if (store.getters['common/agentPlatId']) {
      key = 'OnlineServiceDialogQiYuAppID' + '_' + store.getters['common/agentPlatId'];
    }
    if (!appKey) {
      Post(
        apiName.GetPublicConfigValue,
        { key },
        (res) => {
          if (GetResultState(res)) {
            store.commit('temporary/setAppkey', res.Value);
            resolve(res.Value);
          } else {
            reject(res.Message);
          }
        },
        null,
        true,
      );
    } else {
      resolve(appKey);
    }
  });
}

// 获取普通客服组
export function getDefaultGroupId() {
  return new Promise((resolve, reject) => {
    const defaultGroupId = store.state.temporary.defaultGroupId;
    let key = 'CustomerServiceTeam';
    if (store.getters['common/agentPlatId']) {
      key = 'CustomerServiceTeam' + '_' + store.getters['common/agentPlatId'];
    }
    if (!defaultGroupId) {
      Post(
        apiName.GetPublicConfigValue,
        { key },
        (res) => {
          if (GetResultState(res)) {
            store.commit('temporary/setDefaultGroupId', res.Value);
            resolve(res.Value);
          } else {
            reject(res.Message);
          }
        },
        null,
        true,
      );
    } else {
      resolve(defaultGroupId);
    }
  });
}

// productType业务线 orderNo订单号 orderStatus订单状态
export async function jumpOnlineService({ productType = '', orderNo = '', orderStatus = '', groupid = '' } = {}) {
  const url = await generateUrl(productType, orderNo, orderStatus, groupid);
  uni.navigateTo({
    url,
  });
}
